import React from "react";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

// Logo
import vertexsuiteLogo from './image/vertexSuiteLogo.webp';
import logo from './image/Logos.png';
import atmikBharat_Logo from './image/ATMIK BHARAT LOGO.png';

const Footer = () => {
  return (
    <section
      className="pt-5 position-relative footer"
      style={{
        overflow: "hidden",
        background:
          "linear-gradient(180deg, #fafdff 0%, #eaf3ff 45%, #ffffff 100%)",
      }}
    >
      <div
        className="mx-auto position-relative"
        style={{ maxWidth: '88%' }}
      >
        {/* top grid */}
        <div className="ft-grid px-3 px-md-5">
          {/* left column */}
          <div>
            {/* Both logos at top */}
            <div className="ft-brand">
              <img src={logo} alt="Vertex Suite" className="ft-logo" />
            </div>

            {/* contact + company */}
            <div className="ft-contact">
              <div className="icon-wrapper">
                <MdOutlineEmail className="ft-mail" />
              </div>
              <a href="mailto:info@atmikhbarat.com">info@atmikbharat.com</a>
            </div>

            {/* <h4 className="ft-company">Atmik Bharat Industries Private Limited</h4> */}
            <div className="ft-company-wrap">
              <div className="ft-company-logo">
                <img src={atmikBharat_Logo} alt="Atmik Bharat" />
              </div>
              <h4 className="ft-company">Atmik Bharat Industries Private Limited</h4>
            </div>

            <div className="ft-addr">
              <div className="ft-addr-title">
                <div className="icon-wrapper">
                  <FaLocationDot className="ft-location" />
                </div>
                <span>Registered office address:</span>
              </div>
              <div className="ft-addr-text">
                R/O 18/10 Radhika Nagar, Supela, Bhilai - 490023, Chhattisgarh
              </div>
            </div>

            <div className="ft-addr">
              <div className="ft-addr-title">
                <div className="icon-wrapper">
                  <FaLocationDot className="ft-location" />
                </div>
                <span>Corporate office address:</span>
              </div>
              <div className="ft-addr-text">
                H.O. Block-86, Plot-2, Nehru Nagar East, Bhilai, Chhattisgarh 490020
              </div>
            </div>

            <div className="ft-addr">
              <div className="ft-addr-title">
                <div className="icon-wrapper">
                  <FaLocationDot className="ft-location" />
                </div>
                <span>Branch office address:</span>
              </div>
              <div className="ft-addr-text">
                {/* B.O.- D116, Dewan Apartement No.1, navghar, Vasai, Maharashtra (E), 401210 */}
                B.O.- Delhi, D116, Dewan Apartement No.1, navghar, near-station,  Vasai Road, East Maharashtra, 401210, India.
              </div>
            </div>

            {/* Social icons at bottom */}
            <div className="ft-socials">
              <a href="#" aria-label="Facebook" className="ft-soc">
                <FaFacebook />
              </a>
              <a href="#" aria-label="X (Twitter)" className="ft-soc">
                <FaXTwitter />
              </a>
              <a href="#" aria-label="Instagram" className="ft-soc">
                <FaInstagram />
              </a>
              <a href="#" aria-label="WhatsApp" className="ft-soc">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="ft-col right-col">
            <h5>Useful Links</h5>
            <a href="#">Help</a>
            <a href="#">Features</a>
            <a href="#">Marketing Partner</a>
            <a href="#">Affiliate Program</a>
            <a href="#">GDPR Compliance</a>
            <a href="#">Book a Demo</a>
            <a href="#">Security</a>
          </div>

          <div className="ft-col right-col">
            <h5>Solutions</h5>
            <a href="#">Social Commerce</a>
            <a href="#">Communication &amp; Marketing</a>
            <a href="#">Order &amp; Inventory</a>
            <a href="#">Shipment &amp; Warehousing</a>
            <a href="#">Multi Vendor</a>
            <a href="#">Analytics</a>
            <a href="#">Finance</a>
          </div>

          <div className="ft-col right-col">
            <h5>Company</h5>
            <a href="#">Integrations</a>
            <a href="#">Blog</a>
            <a href="#">Pricing</a>
            <a href="#">Contact Us</a>
            <a href="#">FAQ's</a>
            <a href="#">Terms &amp; Conditions</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Refund Policy</a>
          </div>

          <div className="ft-col right-col">
            <h5>About</h5>
            <a href="#">About Us</a>
            <a href="#">Join Our Team</a>
            <a href="#">Partners</a>
            <a href="#">Events</a>
            <a href="#">In The News</a>
            <a href="#">Investments</a>
            <a href="#">Sitemap</a>
          </div>
        </div>

        {/* bottom bar */}
        <div className="ft-bottom">
          <div>
            Copyright © 2025
            {'  '}
            <span style={{ fontSize: '1.2rem', color: '#ffffff' }}>Atmik Bharat Industries Private Limited.</span> {' '}
            All rights reserved.
          </div>
          <div className="ft-links">
            <a href="#">Terms of Service</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Refund Policy</a>
          </div>
        </div>
      </div>

      {/* styles */}
      <style>{`
        .ft-grid{
          display:grid;
          grid-template-columns: 1.4fr 1fr 1fr 1fr 1fr;
          gap: 48px;
        }
        @media (max-width: 1200px){
          .ft-grid{ grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 768px){
          .ft-grid{ grid-template-columns: 1fr; }
        }

          /* company line with logo circle */
.ft-company-wrap{
  display:flex;
  align-items:center;
  gap:10px;
  margin:12px 0 10px;
}
.ft-company-logo{
  width:36px;
  height:36px;
  border-radius:50%;
  // background: #e3f0ff; 
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;
}
.ft-company-logo img{
  width:50px;
  height:50px;
  object-fit:contain;
}

      
        .ft-brand{
          display:flex;
          align-items:center;
          gap:30px;   
          margin-bottom:20px;
        } 
           
        .ft-logo{ 
            width: 60%; 
            height:auto; 
            object-fit:contain;
         }

        .ft-meta{ 
            margin-top: 2rem; 
            width:130px; 
            height:auto; 
            object-fit:contain; 
            position: relative; 
            left: -2.8rem; 
        }

        .ft-infinite {
            width: 90px;     
            height: auto;
            object-fit: contain;
            position: relative;
            top: 18px; 
            right: 2.5rem
        }

        .ft-socials{ 
           display:flex; 
           gap:12px; 
           margin:20px 0 0;
         }

        .ft-soc{
          width:45px; 
          height:45px; 
          border-radius:10px;
          display:grid; 
          place-items:center;
          background:#E9F1FA; 
          color:#0A56A2;
          box-shadow: inset 0 1px 0 rgba(255,255,255,.6);
          text-decoration:none;
          transition: transform .15s ease, box-shadow .15s ease;
        }
        .ft-soc:hover{ 
             transform: translateY(-2px); box-shadow: 0 4px 10px rgba(16,24,40,.12);
         }

        .icon-wrapper{
          width:30px;
          height:30px;
          border-radius:50%;
          background: #e3f0ff;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .ft-contact{ 
           display:flex; 
           align-items:center; 
           gap:10px; 
           margin:4px 0 16px; 
           color:#000;
        }

        .ft-mail{ 
           font-size:18px;
           color:#054E91;
         }

        .ft-contact a{ 
            color: #242121ff; 
            text-decoration:none;
            font-size:1.15rem;
            font-family: Inter;
            font-weight: 550;
         }

        .ft-company{ 
            margin:12px 0 10px; 
            font-size: 1.1rem; 
            font-family: Inter;
            color: #413e3eff;
            font-weight: 520;
            white-space:nowrap;
        }

        .ft-addr{ 
           margin-bottom:10px;
         }

        .ft-addr-title{ 
            font-size:1.1rem;
            font-weight:550; 
            font-family: Inter;
            color: #242121ff;  
            margin-bottom:4px; 
            display:flex;
            align-items:center;
            gap:8px;
            white-space:nowrap;
        }

        .ft-location{
            font-size:14px;
            color:#054E91;
        }

        .ft-addr-text{
            font-size: 15px; 
            font-family: Inter; 
            font-weight:400; 
            color: #413e3eff; 
            line-height:1.3;
            margin-left: 2.3rem;
         }

        .ft-col h5{
            margin:0 0 12px;
            color:#054E91;
            font-size: 19px; 
            font-family: Inter;         
            line-height:1.1;
            font-weight:600;
            white-space:nowrap;      
            text-wrap:nowrap;        

         }

        .ft-col a{ 
             display:block; 
             color: #413e3eff; 
             text-decoration:none;
             margin:6px 0; 
             font-size:15px;
             font-family: Inter;
             font-weight:400;
        }

        .ft-col a:hover{ 
           color:#0A56A2; 
        }

        .ft-bottom{
          margin-top:28px; 
          display:flex; 
          justify-content:space-between; 
          align-items:center;
          gap:12px; 
          color: #f3f4f6ff; 
          font-size:1rem;
          background-color: #054E91;
          padding: 24px;
          // border-radius:8px;
          padding-left: 50px;
          padding-right: 50px;
        }

        .ft-links{ 
            display:flex; 
            align-items:center; 
            gap: 2.7rem; 
        }

        .ft-links a{ 
           font-size: 1rem;
           color: #ffffff; 
           text-decoration:none; 
        }
        .ft-links a:hover{ color:#E9F1FA; }
        .ft-links span{ color:white; }

        /*right side  */
        .right-col{ 
           margin-top: 8rem;
           padding-left:7.6rem; 
        }
      `}
      </style>
    </section>
  );
};

export default Footer;